// react
import { useDispatch } from 'react-redux';

// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { useNavigate } from '@tanstack/react-router';

// api
import {
  type PostAlarmConfigurationDto,
  usePostAlarmConfigurationMutation,
} from '@/api/generated/recalc/endpoints/v2/alarmConfiguration';

// components
import { showSnackbar } from '@/redux/snackbarSlice';

export function useCreateAlarmConfiguration() {
  const { t } = useTranslation('alarms');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [postAlarmConfiguration, { isLoading: isCreating }] =
    usePostAlarmConfigurationMutation();

  const createAlarmConfiguration = async (
    createPayload: PostAlarmConfigurationDto,
  ) => {
    const result = await postAlarmConfiguration({
      postAlarmConfigurationDto: createPayload,
    });

    if (!('error' in result)) {
      dispatch(
        showSnackbar({
          message: t('messages.alarm_configuration_created', {
            defaultValue: 'Alarm configuration created successfully',
          }),
          severity: 'success',
        }),
      );

      navigate({ to: '../..' });
      return true;
    }
    // Errors are handled globally by apiErrorMiddleware (snackbar + App Insights).
    return false;
  };

  return {
    createAlarmConfiguration,
    isCreating,
  };
}
